import requests from "./httpService";

const WithdrawServices = {

    getAllWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/withdraw/all?page=${page}&limit=${limit}`);
    },
    
    getPendingWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/withdraw/pending?page=${page}&limit=${limit}`);
    },
    
    getApproveWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/withdraw/success?page=${page}&limit=${limit}`);
    },

    getRejectedWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/withdraw/reject?page=${page}&limit=${limit}`);
    },
    
    getWithdrawDetails: async (id) => {
        const res= requests.get(`/withdraw/${id}`);
        return res
    },
    approveWithdraw: async (id, body) => {   
        return requests.put(`/withdraw/${id}/approve`, body);
    },
    
    rejectWithdraw: async (id,body) => {
        return requests.put(`/withdraw/${id}/reject`, body);
    },
    
  updateWithdrawStatus: async (id, body) => {
        return requests.put(`/withdraw/${id}`, body);
    },
    deleteWithdraw: async (id) => {
        return requests.delete(`/withdraw/${id}`);
    }
};

export default WithdrawServices;